module.exports = new __parcel__URL__("ding.5236e861.wav").toString();